import { FC, PropsWithChildren } from "react";

export const DevOnly: FC<PropsWithChildren> = ({ children }) => {
  if (import.meta.env.DEV) return children;
  return null;
};
